export enum CommonNotifications {
  // Internet Connection
  NoInternetConnection = 'E6IS',
  NoInternetDescription = '+n5w',

  // Network Connection
  NoNetworkConnection = 'jyHV',
  NoNetworkDescription = 'q+qC',
}
